import isJSON from "./isJSON.util";

export const getParsedJSON = (objectToParse: any): any => {
  return isJSON(objectToParse) ? JSON.parse(objectToParse) : objectToParse;
};
